// Откладывание предложения включить уведомления. Здесь и только здесь мы храним
// решение человека «не сейчас»; компонент знает лишь ответ да/нет — тот же приём,
// что в lib/push.ts и lib/install.ts.
//
// В отличие от полосы установки (там sessionStorage, «спрятать до конца сеанса»)
// снуз живёт в localStorage и на неделю. Причина в разной цене отказа: установка —
// удобство, её можно предлагать в каждом новом сеансе; уведомления человек либо
// осознанно не хочет, либо просто был занят. Неделя — компромисс: спрашиваем
// повторно, но не на каждый заход.
const SNOOZED_UNTIL_KEY = 'push_prompt_snoozed_until'

const SNOOZE_DAYS = 7

const SNOOZE_MS = SNOOZE_DAYS * 24 * 60 * 60 * 1000

export function snoozePrompt(): void {
  try {
    localStorage.setItem(SNOOZED_UNTIL_KEY, String(Date.now() + SNOOZE_MS))
  } catch {
    // Приватный режим Safari и переполненное хранилище бросают на запись. Полоса
    // просто останется видимой — ронять из-за этого страницу нельзя.
  }
}

export function promptSnoozed(): boolean {
  try {
    const raw = localStorage.getItem(SNOOZED_UNTIL_KEY)
    if (!raw) return false

    const until = Number(raw)
    // Битое значение (руками правили, старый формат, чужой ключ) читаем как
    // «снуза нет»: молчать навсегда из-за нечитаемой строки хуже, чем спросить
    // лишний раз.
    if (!Number.isFinite(until)) return false

    return Date.now() < until
  } catch {
    return false
  }
}
